/**
 * @ngdoc directive
 * @name kareo.ui.shared.assets:kCurrency
 * @element input
 * @function
 * @description
 * Formats a number as a currency (ie $1,234.56).
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @example
 <example module="kareo.ui.shared.directives.currency">
 <file name="index.html" >
 <p>
 <input type="text" k-currency ng-init="currency.amount=1234.56" ng-model="currency.amount" />
 - Model:  {{currency.amount}}
 </p>
 </file>
 </example>
 */

angular.module('kareo.ui.shared.directives.currency', [])
  .directive('kCurrency', [
    '$filter', function idCurrencyInjectingFunction($filter) {
      return {
        require: 'ngModel', restrict: 'A', link(scope, element, attr, ctrl) {
          angular.element(element).bind('blur', elementBlur);
          ctrl.$parsers.push(viewValueChange);
          ctrl.$formatters.unshift(modelChange);
          if (attr.min) {
            ctrl.$parsers.push(minValidator);
            ctrl.$formatters.push(minValidator);
          }
          function elementBlur(e) {
            scope.$apply(() => {
              var viewValue = element.val();
              if (viewValue === '' || typeof viewValue === 'undefined') {
                return;
              }
              var formatted = formatToCurrency(stripToNumber(viewValue));
              if (ctrl.$viewValue === formatted) {
                return;
              }
              element.val(formatted);
              ctrl.$setViewValue(formatted);
            });
          }

          function stripToNumber(num) {
            num = num || '';
            var number = parseFloat(num.replace(/[^0-9|^\.|^-]+/g, ''));
            if (isNaN(number)) {
              return undefined;
            }
            return number;
          }

          function formatToCurrency(number) {
            if (number < 0) {
              return '-' + $filter('currency')(number * -1);
            }
            return $filter('currency')(number) || '';
          }

          function viewValueChange(viewValue) {
            var decimal = stripToNumber(viewValue);
            return decimal;
          }

          function modelChange(modelVal) {
            var val = modelVal;
            return formatToCurrency(val);
          }

          function minValidator(number) {
            var min = scope.$eval(attr.min);
            ctrl.$setValidity('min', number >= min);
            return number;
          }
        }
      };
    }]);
